import React, { Suspense, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormControl, InputLabel, MenuItem, Select, FormHelperText } from "@mui/material";
import * as Yup from "yup";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import Dialogs from "../Dialogs";
import Loading from "../Loading";
import { TroubleshootTwoTone } from "@mui/icons-material";
import theme from "../../constants/theme";

const validationSchema = Yup.object({
    primarySpecialtyId: Yup.string().required("Required Field!"),
});

const DoctorSelection = ({ selectedId, userId, comment, isOpen, onClose, isEdit }) => {
    //------------STATE----------------
    const dispatch = useDispatch();
    const categories = useSelector((state) => state.category.list);
    const [isLoading, setLoading] = useState(TroubleshootTwoTone);
    const { t } = useTranslation();

    //--------------Handler---------------------
    const handleOnSubmit = async (e) => {
        try {
            setLoading(true);
            toast.info("Bu özellik devre dışı bırakıldı.");
            onClose();
        } catch (err) {
            toast.error(t("error_occured"));
            console.error(err);
        } finally {
            setLoading(false);
        }
    }
    //---------USE EFFECT---------------
    useEffect(() => {
        setLoading(false);
    }, [])
    //-------FORMIK-------------------
    const { handleSubmit, handleChange, handleBlur, touched, errors, resetForm, values, setFieldValue } = useFormik({
        initialValues: {
            primarySpecialtyId: ""
        },
        validationSchema: validationSchema,
        validateOnBlur: true,
        onSubmit: (e) => {
            handleOnSubmit(e);
            onClose(true);
            resetForm();
        },
    });

    return (
        <Dialogs.Form maxWidth="md" onClose={onClose} isOpen={isOpen} onSubmit={handleSubmit} title={t("assign_to_branch")}>
            {isLoading ? <Loading /> :
                <>
                    <div style={{ padding: "1rem" }}>
                        <Suspense fallback={<div></div>}>
                            <FormControl fullWidth error={Boolean(errors.primarySpecialtyId) && touched.primarySpecialtyId}>
                                <InputLabel sx={{ backgroundColor: theme.palette.background.paper, paddingLeft: 0.5, paddingRight: 0.5 }} id="primarySpecialtyId">{t("select_branch")}</InputLabel>
                                <Select
                                    labelId="primarySpecialtyId"
                                    id="primarySpecialtyId"
                                    name="primarySpecialtyId"
                                    value={values.primarySpecialtyId}
                                    label={t("select_branch")}
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    defaultValue=""
                                >
                                    {categories?.map((c, index) => (
                                        <MenuItem key={index + 1} value={c.id}>
                                            {t(c.title)}
                                        </MenuItem>
                                    ))}
                                </Select>
                                {touched.primarySpecialtyId && Boolean(errors.primarySpecialtyId) &&
                                    <FormHelperText>{errors.primarySpecialtyId}</FormHelperText>
                                }
                            </FormControl>
                        </Suspense>
                    </div>
                </>
            }
        </Dialogs.Form>
    );
};

export default DoctorSelection;
